<template>
  <table class="calendar">
    <thead>
      <tr>
        <th abbr="Sunday">Sun</th>
        <th abbr="Monday">Mon</th>
        <th abbr="Tuesday">Tue</th>
        <th abbr="Wednesday">Wed</th>
        <th abbr="Thursday">Thu</th>
        <th abbr="Friday">Fri</th>
        <th abbr="Saturday">Sat</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(week, w) in calendar" :key="w">
        <td
          v-for="(day, d) in week"
          :key="d"
          :class="dayClass(day)"
          @click="daySelected(day)"
        >
          <slot v-if="!day.disabled" name="day" :day="day.day">
            <span class="date">{{ day.day }}</span>
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    month: { type: String },
    selected: { type: Number },
    customClassnames: { type: Object },
  },
  data() {
    return {
      currentMonth: this.$moment().format("YYYY-MM"),
    };
  },
  computed: {
    startDayOfTheWeek() {
      return parseInt(this.$moment(this.currentMonth).format("d"), 10);
    },
    lastDayOfTheMonth() {
      return parseInt(
        this.$moment(this.currentMonth).endOf("month").format("D"),
        10
      );
    },
    firstDay() {
      return this.$moment(this.currentMonth).subtract(
        this.startDayOfTheWeek,
        "days"
      );
    },
    calendar() {
      let grid = [];
      let date = this.firstDay;
      for (var w = 1; w < 7; w++) {
        var row = [];
        var lastRow = false;
        for (var d = 0; d < 7; d++) {
          var day = parseInt(date.format("D"), 10);
          row.push({
            day: day,
            disabled: date.format("YYYY-MM") != this.currentMonth,
          });
          if (
            date > this.$moment(this.currentMonth).startOf("month") &&
            day >= this.lastDayOfTheMonth
          ) {
            lastRow = true;
          }
          date.add(1, "days");
        }
        grid.push(row);

        if (lastRow) {
          break;
        }
      }
      return grid;
    },
  },
  watch: {
    month(val) {
      this.setMonth(val);
    },
  },
  methods: {
    setMonth(val) {
      if (
        typeof val == "string" &&
        val.match(/^[0-9]{4}\-[0-9]{2}$/g) !== null
      ) {
        this.currentMonth = val;
      }
    },
    isCurrentDate(day) {
      return (
        this.$moment(this.currentMonth).format("YYYY-MM") ==
          this.$moment().format("YYYY-MM") &&
        day == parseInt(this.$moment().format("D"), 10)
      );
    },
    dayClass(day) {
      var classnames = [];

      if (day.disabled) {
        classnames.push("disabled");
      } else if (!day.disabled && this.selected == day.day) {
        classnames.push("selected");
      } else if (this.isCurrentDate(day.day)) {
        classnames.push("current");
      }

      var date = this.$moment(this.currentMonth)
        .date(day.day)
        .format("YYYY-MM-DD");
      if (
        !_.isEmpty(this.customClassnames) &&
        _.has(this.customClassnames, date)
      ) {
        classnames.push(this.customClassnames[date]);
      }

      return classnames.join(" ");
    },
    daySelected(day) {
      if (!day.disabled) {
        this.$emit("day-selected", day.day);
      }
    },
  },
  created() {
    this.setMonth(this.month);
  },
};
</script>
